/** ==================== Profile ==================== */
export interface CareerMentorProfileData {
  phone?: string
  verifiedPhone?: boolean
  personalEmail?: string
  birthDate?: string
}

/** ==================== Requests ==================== */
export interface CareerMentorUpdatePhoneParams {
  phone: string
  personalEmail?: string
  birthDate?: string
}

export interface CareerMentorActiveMessageParams {
  templateName: string
  language: string
  searchTerm?: string
  /**
   * A cauda do link que o botão do template carrega, com o `?` — a base fica cadastrada na Meta e
   * só isto varia por envio. Só o template do app usa.
   */
  skillAppUrlParams?: string
}

/** ==================== Message Templates ==================== */
export const CAREER_MENTOR_MESSAGE_TEMPLATE = {
  CONTACT_REQUEST: 'respond_contact_request_template',
  CONTACT_REQUEST_FROM_SEARCH: 'respond_contact_request_from_search_template',
  /** A Sofie manda o link do app. O botão é dinâmico: `skill_app_url_params` é a cauda dele. */
  SEND_APP_LINK: 'send_app_link_template'
} as const

export type CareerMentorTemplateName =
  (typeof CAREER_MENTOR_MESSAGE_TEMPLATE)[keyof typeof CAREER_MENTOR_MESSAGE_TEMPLATE]
